import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { gqlGroupMember } from '../Groups/getGroupMember.api';
import { BillingParty } from '../../graphql/billing_party.datatypes';

interface BillingPartyData {
    billingParty: BillingParty
}

export const gqlBillingPartyMember = `
        id
        user_id
        primary_paying_member
        first_name
        last_name
        email
        address_line_1
        address_line_2
        city
        state
        zipcode
        country
        primary_phone
        primary_phone_code
        secondary_phone
        secondary_phone_code
        notes
        billing_party_id
        is_group_leader
        hasAutomaticPayment
        automaticPayment {
            id
            payment_token
            payment_type
            payment_frequency
            last_four
            routing_number
        }

        user {
            id
            email
          cellphone
          cellphone_code
        }
`;

export const gqlBillingParty = `
    id
    group_booking_id
    payment_schedule_id
    credit_card_fee
    soft_cancelled
    disabled
    credit_card_fee_paid
    code
    has_pastdue_payments
    comp_credit_eligible

    cost
    outstandingBalance
    overduePayments
    totalPayments
    totalRefunds
    totalReceived
    totalCredit
    totalCreditCardFees

    payingMembers {
        ${gqlBillingPartyMember}
    }

    payments {
        id
    }

    booking {
      id
      created_at
      start_date
      end_date

      group {
        id
        name
        booking_form_url
        credit_card_fee
        booking_tool_edit_cutoff

        tour {
            id
            internal_name
            display_name
        }
        hotel {
            id
            internal_name
            display_name
        }
      }

      roomParties {
        id
        members {
            id
            billing_party_id
            cost

            groupMember {
                id
                group_id
                user_id
                first_name
                last_name
                email
                cellphone_code
                cellphone
                dob
                group_role
                validated
                cancelled
                disabled
                authorised
                ageAtEvent

                group {
                    id
                    name
                }
            }
        }
      }
    }

    members {
        id
        billing_party_id
        group_member_id
        cost

        groupMember {
            ${gqlGroupMember}
        }

        roomParty {
            id
            disabled
            start_date
            end_date
        }
    }

    payment_schedule {
        id
    }

    group {
        id
        name
        members {
            id
            first_name
            last_name
            cancelled
        }

        tour {
            id
            comms_email_address
            terms_and_conditions
            cancellation_policy
        }
    }

    adjustments {
        id
        adjustment_type
        amount
        description
    }
`;

export const GET_BILLING_PARTY_QUERY = gql`
    query billingParty($id: Int!){
        billingParty(id: $id){
            ${gqlBillingParty}
        }
    }
`;

export const getBillingParty = (partyId: number | null) => {
  const id = partyId ? partyId : -1;
  return useQuery<BillingPartyData>(
    GET_BILLING_PARTY_QUERY,
    {
      variables: {id},
    }
  );
};

export default getBillingParty;
